import { FeatureFlag } from '@/common';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { DEFAULT_AGENT, DEFAULT_MODEL } from '@/features/prince/models';
import { Navigate, Route, Routes } from 'react-router-dom';
import { FeatureFlagProtectedRoute } from '../components/FeatureFlagProtectedRoute';
import { useCanvasContext } from '../hooks/useCanvasContext';
import AdminPromptsPage from './AdminPromptsPage';
import ConversationPage from './ConversationPage';
import Error from './Error';
import Layout from './Layout';
import LoginPage from './LoginPage';
import NotFoundPage from './NotFoundPage';
import PrincePage from './PrincePage';
import ProfilePage from './ProfilePage';
import PromptDetailPage from './PromptDetailPage';
import Storage from './StoragePage';
import SummaryPage from './SummaryPage';

export default function AppRoutes() {
  const isCanvas = useCanvasContext()?.isCanvas;

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Main routes with conditional layout (Canvas vs Normal) */}
      <Route path="/" element={isCanvas ? null : <Layout />}>
        <Route
          index
          element={<Navigate to={`/prince/${DEFAULT_AGENT}/${DEFAULT_MODEL}`} replace />}
        />
        <Route
          path="storage/:objectName?/:recordId?"
          element={
            <ProtectedRoute>
              <Storage />
            </ProtectedRoute>
          }
        />
        <Route
          path="record-summary/:objectName?/:recordId?"
          element={
            <FeatureFlagProtectedRoute flag={FeatureFlag.SCOUT_RECORD_SUMMARIES}>
              <ProtectedRoute>
                <SummaryPage />
              </ProtectedRoute>
            </FeatureFlagProtectedRoute>
          }
        />
        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        {/* New parameterized Prince route */}
        <Route
          path="prince/:agent/:model"
          element={
            <ProtectedRoute>
              <PrincePage />
            </ProtectedRoute>
          }
        />
        {/* Conversations route */}
        <Route
          path="conversations"
          element={
            <FeatureFlagProtectedRoute flag={FeatureFlag.SCOUT_DIRECT_MESSAGING}>
              <ProtectedRoute>
                <ConversationPage />
              </ProtectedRoute>
            </FeatureFlagProtectedRoute>
          }
        />
        <Route
          path="admin/prompts"
          element={
            <FeatureFlagProtectedRoute flag={FeatureFlag.SCOUT_PROMPT_ADMIN}>
              <ProtectedRoute>
                <AdminPromptsPage />
              </ProtectedRoute>
            </FeatureFlagProtectedRoute>
          }
        />
        <Route
          path="admin/prompts/:promptId"
          element={
            <FeatureFlagProtectedRoute flag={FeatureFlag.SCOUT_PROMPT_ADMIN}>
              <ProtectedRoute>
                <PromptDetailPage />
              </ProtectedRoute>
            </FeatureFlagProtectedRoute>
          }
        />
        <Route path="error" element={<Error />} />
        {/* Catch-all route for unmatched paths */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
